/**
* Tab HTML
*/
class customTabs extends HTMLElement {
    constructor() {
      super();
  
      this.tabLinks = this.querySelectorAll('.tablink');
      this.tabContainers = this.querySelectorAll('.tabcontent');
  
      this.tabLinks.forEach( link => link.addEventListener('click', this.toggleTabs.bind(this)));
    }
  
    /**
     * Escape Key Press to close drawer when focus is within the container
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
    }
  
    /**
     * Toggle Tabs on link click
     *
     * @param {event} Event instance
     */
    toggleTabs(event){
      event.preventDefault();
      event.stopPropagation();
      const currentTab = event.currentTarget;
      const tabLink = currentTab.querySelector('[data-toggle="tab"]');
      const tabContainer = document.querySelector(tabLink.dataset.tabcontent);
  
      this.openTab(currentTab, tabContainer)
    }
  
    /**
     * Open Tab Container
     *
     * @param {Node} currentTab Tab Container Open link
     * @param {Node} tabContainer Tab Container to open
     */
    openTab(currentTab, tabContainer) {
      this.tabContainers.forEach(container => {
        container.classList.remove('open');
        const linkEle = document.querySelector('.tablink a[data-toggle="tab"][data-tabcontent="#'+container.id+'"]');
        if(linkEle){
          linkEle.setAttribute('aria-expanded', false);
          if(linkEle.closest('.tablink')){ linkEle.closest('.tablink').classList.remove('open');}
        }
      });
      currentTab.classList.add('open');
      currentTab.querySelector('[data-toggle="tab"]').setAttribute('aria-expanded', true);
      tabContainer.classList.add('open');
    }
  }
  customElements.define("custom-tabs", customTabs);
  
  /**
  * Accordion HTML
  */
  class customAccordion extends HTMLElement {
    constructor() {
      super();
      this.accordionType = this.dataset.accordiontype;
      this.toggleBtns = this.querySelectorAll('.accordion__toggle');
  
      this.toggleBtns.forEach(button => button.addEventListener('click', this.toggleAccordionBlock.bind(this)));
    }
  
    /**
     * Escape Key Press to close drawer when focus is within the container
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
    }
  
    /**
     * Toggle Tabs on link click
     *
     * @param {event} Event instance
     */
     toggleAccordionBlock(event){
      event.preventDefault();
      const toggleBtn = event.currentTarget;
      const targetContainer = toggleBtn.parentNode;
      const isOpen = targetContainer.classList.contains('open');
      isOpen ? this.closeAccordionBlock(toggleBtn) : this.openAccordionBlock(toggleBtn);
    }
  
    /**
     * Open Tab Container
     *
     * @param {Node} toggleBtn Accordion Block Open link
     */
     openAccordionBlock(toggleBtn) {
      let targetContainer = toggleBtn.parentNode;
      toggleBtn.setAttribute('aria-expanded', true);
      Utility.toggleElement(targetContainer, 'open');
      if(this.accordionType == 'single'){
        let siblingBlocks = targetContainer.parentNode.querySelectorAll('.accordion__container');
        siblingBlocks.forEach(element => {
          if(element == targetContainer){ return; }
          element.classList.remove('open');
          element.querySelector('.accordion__block').classList.remove('open');
          element.querySelector('.accordion__toggle').setAttribute('aria-expanded', false);
        });
      }
      Utility.trapFocus(targetContainer);
    }
  
    /**
     * Close Tab Container
     *
     * @param {Node} currentTab Tab Container link
     * @param {Node} tabContainer Tab Container to close
     */
     closeAccordionBlock(toggleFilterBtn) {
      const targetContainer = toggleFilterBtn.parentNode;
      toggleFilterBtn.setAttribute('aria-expanded', false);
      Utility.toggleElement(targetContainer, 'close');
      Utility.removeTrapFocus(targetContainer);
    }
  }
  customElements.define("custom-accordion", customAccordion);
  
  /**
    * collaspsibleTab element Events and Methods
    *
    * @param {element} element - Dropdown element
    */
  function initCollaspsibleTab(element){
  
    /** Toggle each filter block container containing values for dropdown effect **/
    let tabToggleBtn = element.querySelector('.tab_toggle');
    tabToggleBtn.addEventListener('click', toggleTab.bind(this));
  
    /**
     * Toggle Filter drawer
     * @param {event} event 
    */
    function toggleTab(event) {
      event.preventDefault();
      const toggleFilterBtn = event.currentTarget;
      const filterContainer = toggleFilterBtn.closest('.tab_container');
      const isOpen = filterContainer.classList.contains('open');
      isOpen ? closeTab(toggleFilterBtn) : openTab(toggleFilterBtn);
    }
  
    /**
     * Open Filter Block
     * @param {element} toggleFilterBtn 
     */
     function openTab(toggleFilterBtn) {
      let filterContainer = toggleFilterBtn.closest('.tab_container');
      toggleFilterBtn.setAttribute('aria-expanded', true);
      Utility.toggleElement(filterContainer, 'open');
      Utility.trapFocus(filterContainer);
    }
  
    /**
     * Close Filter Block
     * @param {element} toggleFilterBtn 
     */
    function closeTab(toggleFilterBtn) {
      const filterContainer = toggleFilterBtn.closest('.tab_container');
      toggleFilterBtn.setAttribute('aria-expanded', false);
      Utility.toggleElement(filterContainer, 'close');
      Utility.removeTrapFocus(filterContainer);
    }
  }
  
  const allCollaspsibleTabs = document.querySelectorAll('[is="collaspsibleTab"]');
  allCollaspsibleTabs.forEach(function(ele) {
    initCollaspsibleTab(ele)
  });


  class customSelect extends HTMLElement{
    constructor() {
      super();
      this.selectContainer = this.querySelector('.custom-dropdown');
      this.select = this.querySelector('ul');
      this.initOption = this.querySelector('.default');

      // Defensive null checks - prevents errors if required elements don't exist
      if (!this.select || !this.selectContainer || !this.initOption) {
        console.warn('customSelect: required elements not found');
        return;
      }

      this.options = this.select.querySelectorAll('li');

      this.options.forEach(option => option.addEventListener('click', this.toggleOptions.bind(this)));
      this.initOption.addEventListener('click', this.manageVisibility.bind(this));

      this.addEventListener('click', (event) => {
        event.stopPropagation();
      });
      document.body.addEventListener('click', ()=> {
        if (this.selectContainer) {
          Utility.toggleElement(this.selectContainer, 'close');
        }
      });
    }
  
    /**
     * Toggle custom select option
     * @param event 
     */
    toggleOptions(event){
      let _this = event.currentTarget;
      this.options.forEach(option => option.classList.remove('selected'));
      _this.classList.add('selected');
      this.initOption.querySelector('.option_txt').innerHTML = _this.querySelector('.option_txt').innerHTML;
      _this.closest('.custom-dropdown').classList.add('selected');
      Utility.toggleElement(this.selectContainer, 'close');
    }
  
    /**
     * Hide/Show of custom select option
     * @param _event 
     */
      manageVisibility(_event){
        let isOpen = this.selectContainer.classList.contains('open');
        isOpen ? Utility.toggleElement(this.selectContainer, 'close') : Utility.toggleElement(this.selectContainer, 'open');
      }
  }
  customElements.define('custom-select', customSelect);

  

  
  